<template>
  <div style="height:100%">
    <!-- Start skeleton loader -->
    <b-row
      v-if="isLoadingList"
      class="position-relative task-dashboard-row pt-4 mx-0"
    >
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 mb-3 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 3"
                    :key="generateId(index)"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 mb-3 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 2"
                    :key="index"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 mb-3 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 2"
                    :key="index"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 mb-3 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 2"
                    :key="index"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- End skeleton loader -->
    <!-- Start task dashboard cards -->
    <b-row
      v-if="statusLoaded"
      ref="taskDashboardRow"
      class="position-relative task-dashboard-row pt-5"
    >
      <b-col md="4" xl="3" lg="5" sm="6" cols="12" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': dailyTasks.length,
            'empty-task-cards-wrapper': !dailyTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_new_task.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listOneTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :cardCount="dailyTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[0]"
              :board="BOARDS.CUSTOMER"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :get-child-payload="getChildPayload1"
              group-name="1"
              :drag-handle-selector="dragHandleSelector"
              class="container daily-container"
              @drag-start="dragListener"
              @drag-end="dragListener"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('dailyTasks', $event)"
            >
              <Draggable v-for="item in dailyTasks" :key="item.id">
                <TaskCards
                  :isLoadingList="isLoadingList"
                  :priority="item.priority === 'high' ? true : false"
                  :cardData="item"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :list="dailyTasks"
                  :shouldPatch="shouldPatch"
                  :statusTitle="listOneTitle"
                  :trackerID="item.lastTracker.id"
                  @card-moved="onCardMoved"
                  :status="statusIdOne"
                  :profileId="profileId"
                  v-on:updateQueue="reloadQueues"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerDaily"
                :identifier="dailyInfiniteId"
                force-use-infinite-wrapper=".daily-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[todoTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              v-if="role === 'assistant'"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdOne, true)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="12" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': todoTasks.length,
            'empty-task-cards-wrapper': !todoTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_today.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listTwoTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :cardCount="todoTasks.length"
              :board="BOARDS.CUSTOMER"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[1]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :get-child-payload="getChildPayload2"
              group-name="1"
              :drag-handle-selector="dragHandleSelector"
              class="container todo-container"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('todoTasks', $event)"
            >
              <Draggable v-for="item in todoTasks" :key="item.id">
                <TaskCards
                  :isLoadingList="isLoadingList"
                  :priority="item.priority === 'high' ? true : false"
                  :cardData="item"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :list="todoTasks"
                  :shouldPatch="shouldPatch"
                  :statusTitle="listTwoTitle"
                  :trackerID="item.lastTracker.id"
                  :status="statusIdTwo"
                  :profileId="profileId"
                  v-on:updateQueue="reloadQueues"
                  @card-moved="onCardMoved"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                :identifier="todoInfiniteId"
                force-use-infinite-wrapper=".todo-container"
                @infinite="infiniteHandlerTodo"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[todoTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              v-if="role === 'assistant'"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdTwo, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="12" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': laterTasks.length,
            'empty-task-cards-wrapper': !laterTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_later.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listThreeTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :cardCount="laterTasks.length"
              :board="BOARDS.CUSTOMER"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[2]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :get-child-payload="getChildPayload3"
              class="container later-container"
              group-name="1"
              :drag-handle-selector="dragHandleSelector"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('laterTasks', $event)"
            >
              <Draggable v-for="item in laterTasks" :key="item.id">
                <TaskCards
                  :isLoadingList="isLoadingList"
                  :priority="item.priority === 'high' ? true : false"
                  :cardData="item"
                  :list="laterTasks"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :trackerID="item.lastTracker.id"
                  :statusTitle="listThreeTitle"
                  v-on:updateQueue="reloadQueues"
                  @card-moved="onCardMoved"
                  :shouldPatch="shouldPatch"
                  :status="statusIdThree"
                  :profileId="profileId"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerLater"
                :identifier="laterInfiniteId"
                force-use-infinite-wrapper=".later-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[laterTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              v-if="role === 'assistant'"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdThree, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="12" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': inProgressTasks.length,
            'empty-task-cards-wrapper': !inProgressTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_in_progress.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listFourTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :cardCount="inProgressTasks.length"
              :board="BOARDS.CUSTOMER"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[3]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              :get-child-payload="getChildPayload4"
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
              class="container inprogress-container"
              group-name="1"
              :drag-handle-selector="dragHandleSelector"
              @drop="onDrop('inProgressTasks', $event)"
            >
              <Draggable v-for="item in inProgressTasks" :key="item.id">
                <TaskCards
                  :isLoadingList="isLoadingList"
                  :cardData="item"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :list="inProgressTasks"
                  :statusTitle="listFourTitle"
                  :priority="item.priority === 'high' ? true : false"
                  :shouldPatch="shouldPatch"
                  :trackerID="item.lastTracker.id"
                  :status="statusIdFour"
                  v-on:updateQueue="reloadQueues"
                  @card-moved="onCardMoved"
                  :profileId="profileId"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerInProgress"
                :identifier="inProgressInfiniteId"
                force-use-infinite-wrapper=".inprogress-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[
              inProgressTasks.length === 0 ? 'add-another-task-btn' : null
            ]"
          >
            <h6
              v-if="role === 'assistant'"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdFour, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="12" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': completedTasks.length,
            'empty-task-cards-wrapper': !completedTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_complete.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listFiveTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :cardCount="completedTasks.length"
              :board="BOARDS.CUSTOMER"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[4]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              :get-child-payload="getChildPayload5"
              group-name="1"
              :drag-handle-selector="dragHandleSelector"
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
              class="container completed-container"
              @drop="onDrop('completedTasks', $event)"
            >
              <Draggable v-for="item in completedTasks" :key="item.id">
                <TaskCards
                  :isLoadingList="isLoadingList"
                  :cardData="item"
                  :list="completedTasks"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :shouldPatch="shouldPatch"
                  :priority="item.priority === 'high'"
                  :status="statusIdFive"
                  v-on:updateQueue="reloadQueues"
                  @card-moved="onCardMoved"
                  :trackerID="item.lastTracker.id"
                  :profileId="profileId"
                  :statusTitle="listFiveTitle"
                  :time="getMoment(item)"
                  :paused="true"
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                :identifier="completedInfiniteId"
                force-use-infinite-wrapper=".completed-container"
                @infinite="infiniteHandlerCompleted"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <!-- <div
            class="d-flex ml-3"
            :class="[
              completedTasks.length === 0 ? 'add-another-task-btn' : null
            ]"
          >
            <h6
              v-if="role === 'assistant'"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdFive, false)"
            >
              + Add another task
            </h6>
          </div> -->
        </b-card>
      </b-col>
    </b-row>
    <!-- End -->
    <!-- <div
      class="no-assigned-msg position-absolute d-flex flex-column justify-content-center align-items-center"
      v-if="showEmptyTasksMsg"
    >
      <h4 class="primary--text font-family-medium">
        No tasks created yet.
      </h4>
    </div> -->
    <b-avatar
      v-if="role === 'assistant'"
      button
      @click="navigate(statusIdTwo, false)"
      size="4.8rem"
      class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      v-model="showAuthError"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container fluid>
        <b-button class="d-flex position-absolute close-btn">
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
      </b-container>
    </b-modal>
    <view-task-modal
      v-model="viewTaskModal.visible"
      @task-deleted="onTaskDeleted"
      @task-archived="onTaskArchived"
      :customerBreadcrumb="showCustomerBreadcrumb"
      @task-handover="reloadAllQueues"
      @timer-started="reloadAllQueues"
      @timer-stopped="reloadAllQueues"
      @status-updated="reloadAllQueues"
      :taskId="viewTaskModal.taskId"
      @navigate="onNavigate"
      :paBreadcrumb="showPABreadcrumb"
    />
  </div>
</template>

<script>
import TaskCards from "@/components/taskcardsComponent/TaskCards.vue";
import moment from "moment";
import { applyDrag } from "@/utils/applyDrag";
import { Container, Draggable } from "vue-smooth-dnd";
import { mapActions, mapState } from "vuex";
import { getCustomerTaskBoard, getTaskStatus, patchTaskBoard } from "@/apis/common";
import ScrollPanner from "@/utils/ScrollPanner.js";
import ViewTaskModal from "@/views/common/ViewTaskModal"
import BulkActionsDropdown from "@/components/dropdowns/BulkActionsDropdown.vue";
import { BOARDS } from '@/utils/constants'
import { isOwner } from "@/utils/utils"

export default {
  name: "CustomerTaskDashboard",
  components: {
    TaskCards,
    ViewTaskModal,
    Draggable,
    Container,
    BulkActionsDropdown
  },
  computed: {
    ...mapState("authModule", ["profileUserId"]),
    // Owners see this board read-only. A selector that matches no element
    // stops a card being lifted at all; null keeps the default behaviour
    // (drag anywhere on the card) for everyone else.
    dragHandleSelector() {
      return isOwner() ? ".owner-drag-disabled" : null;
    },
    showCustomerBreadcrumb() {
      return true
    },
    showPABreadcrumb() {
      if (this.$route.name === "PACustomerDetails") {
        return true
      }
      return false
    },
    showEmptyTasksMsg() {
      return (
        !this.isLoadingList &&
        this.todoTasks.length === 0 &&
        this.laterTasks.length === 0 &&
        this.inProgressTasks.length === 0 &&
        this.completedTasks.length === 0
      );
    }
  },
  mounted() {
    this.actionGetUserDetails()
      .then(res => {
        this.role = res.role;
        this.profileId = this.$route.params.profileId;
        getTaskStatus().then(res => {
          this.statuses = res.data.results.sort(
            (a, b) => a.position - b.position
          );
          console.log(this.statuses);
          this.statusIdOne = this.statuses[0].id;
          this.statusIdTwo = this.statuses[1].id;
          this.statusIdThree = this.statuses[2].id;
          this.statusIdFour = this.statuses[3].id;
          this.statusIdFive = this.statuses[4].id;
          this.listOneTitle = this.statuses[0].title;
          this.listTwoTitle = this.statuses[1].title;
          this.listThreeTitle = this.statuses[2].title;
          this.listFourTitle = this.statuses[3].title;
          this.listFiveTitle = this.statuses[4].title;
          this.statusLoaded = true;
          this.$nextTick(() => {
            new ScrollPanner().initialize(this);
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
  },
  data() {
    return {
      profileId: "",
      customerFullName: "",
      assistantFullName: "",
      viewTaskModal: {
        visible: false,
        taskId: null
      },
      role: "",
      BOARDS,
      statuses: [],
      statusIds: [],
      listOneTitle: "",
      assistants: [],
      listTwoTitle: "",
      listThreeTitle: "",
      listFourTitle: "",
      listFiveTitle: "",
      statusIdOne: "",
      showAuthError: false,
      statusIdTwo: "",
      statusIdThree: "",
      statusIdFour: "",
      statusIdFive: "",
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: false
      },
      limit: 20,
      unAssignedTasks: [],
      todoTasks: [],
      laterTasks: [],
      dailyTasks: [],
      inProgressTasks: [],
      completedTasks: [],
      shouldPatch: false,
      isLoadingList: true,
      statusLoaded: false,
      todoInfiniteId: +new Date(),
      dailyInfiniteId: new Date() * 2,
      laterInfiniteId: new Date() * 3,
      inProgressInfiniteId: new Date() * 4,
      completedInfiniteId: new Date() * 5,
      offsetTodo: 0,
      offsetLater: 0,
      offsetInProgress: 0,
      offsetCompleted: 0,
      offsetDaily: 0,
      reloading: {
        reloadingDaily: false,
        reloadingTodo: false,
        reloadingLater: false,
        reloadingInProgress: false,
        reloadingCompleted: false
      }
    };
  },
  methods: {
    dragListener() {
      // this dummy function is apparently necessary because without it the drag-start and
      // drag-end events don't fire
    },
    onNavigate() {
      this.viewTaskModal.visible = false
    },
    onCardClick(card) {
      this.viewTaskModal.taskId = card.cardData.id
      this.viewTaskModal.visible = true
    },
    onCardDoubleClick(card) {
      const isPACustomerDashboard = !!this.$route.params.uuid
      this.$router.push({
        name: isPACustomerDashboard ? "ViewPACustomerTask" : "ViewCustomerTask",
        params: {
          id: card.cardData.id
        }
      })
    },
    onTaskDeleted() {
      this.reloadAllQueues()
    },
    onTaskArchived() {
      this.reloadAllQueues();
    },
    onBulkAction() {
      this.reloadAllQueues()
    },
    reloadQueues(fromIndex, toIndex, updateSource) {
      let reloadArray = [
        this.reloadDaily,
        this.reloadTodo,
        this.reloadLater,
        this.reloadInProgress,
        this.reloadCompleted
      ];
      let taskArrays = [
        this.dailyTasks,
        this.todoTasks,
        this.laterTasks,
        this.inProgressTasks,
        this.completedTasks
      ];
      if (taskArrays[fromIndex].length < 3 && updateSource) {
        reloadArray[fromIndex]();
      }
      reloadArray[toIndex]();
    },
    reloadAllQueues() {
      this.dailyTasks = [];
      this.todoTasks = [];
      this.laterTasks = [];
      this.inProgressTasks = [];
      this.completedTasks = [];

      this.reloadDaily();
      this.reloadTodo();
      this.reloadLater();
      this.reloadInProgress();
      this.reloadCompleted();
    },
    generateId(index) {
      return (
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9) +
        index
      );
    },
    ...mapActions("authModule", ["actionGetUserDetails"]),
    navigate(id, frequency) {
      if (this.$route.params.uuid) {
        this.$router.push({
          name: "AddPACustomerTask",
          params: {
            uuid: this.$route.params.uuid,
            profileId: this.$route.params.profileId,
            statusID: id,
            frequency: frequency
          }
        });
      } else {
        this.$router.push({
          name: "AddCustomerTask",
          params: {
            profileId: this.$route.params.profileId,
            statusID: id,
            frequency: frequency
          }
        });
      }
    },
    reloadDaily() {
      this.offsetDaily = 0;
      this.reloading.reloadingDaily = true;
      this.dailyInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadTodo() {
      this.offsetTodo = 0;
      this.reloading.reloadingTodo = true;
      this.todoInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadLater() {
      this.offsetLater = 0;
      this.reloading.reloadingLater = true;
      this.laterInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadInProgress() {
      this.offsetInProgress = 0;
      this.reloading.reloadingInProgress = true;
      this.inProgressInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadCompleted() {
      this.offsetCompleted = 0;
      this.reloading.reloadingCompleted = true;
      this.completedInfiniteId += 1;
      this.shouldPatch = false;
    },
    infiniteHandlerDaily($state) {
      let params = {
        status: this.statuses[0].id,
        limit: this.limit,
        offset: this.offsetDaily,
        is_archive: false
      }
      getCustomerTaskBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloading.reloadingDaily) {
            this.dailyTasks = [...res.data.results];
            this.reloading.reloadingDaily = false;
          } else {
            this.dailyTasks = [...this.dailyTasks, ...res.data.results];
          }
          this.offsetDaily = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerTodo($state) {
      let params = {
        status: this.statuses[1].id,
        limit: this.limit,
        offset: this.offsetTodo,
        is_archive: false
      }
      getCustomerTaskBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloading.reloadingTodo) {
            this.todoTasks = [...res.data.results];
            this.reloading.reloadingTodo = false;
          } else {
            this.todoTasks = [...this.todoTasks, ...res.data.results];
          }
          this.offsetTodo = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerLater($state) {
      let params = {
        status: this.statuses[2].id,
        limit: this.limit,
        offset: this.offsetLater,
        is_archive: false
      }
      getCustomerTaskBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloading.reloadingLater) {
            this.laterTasks = [...res.data.results];
            this.reloading.reloadingLater = false;
          } else {
            this.laterTasks = [...this.laterTasks, ...res.data.results];
          }
          this.offsetLater = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerInProgress($state) {
      let params = {
        status: this.statuses[3].id,
        limit: this.limit,
        offset: this.offsetInProgress,
        is_archive: false
      }
      getCustomerTaskBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloading.reloadingInProgress) {
            this.inProgressTasks = [...res.data.results];
            this.reloading.reloadingInProgress = false;
          } else {
            this.inProgressTasks = [
              ...this.inProgressTasks,
              ...res.data.results
            ];
          }
          this.offsetInProgress = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerCompleted($state) {
      let params = {
        status: this.statuses[4].id,
        limit: this.limit,
        offset: this.offsetCompleted,
        is_archive: false
      }
      getCustomerTaskBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloading.reloadingCompleted) {
            this.completedTasks = [...res.data.results];
            this.reloading.reloadingCompleted = false;
          } else {
            this.completedTasks = [...this.completedTasks, ...res.data.results];
          }
          this.offsetCompleted = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    async onCardMoved(card) {
      let payload = {
        status: card.status,
        is_from_customerboard: true,
        completedDate:
          card.statusTitle === "Complete"
            ? moment()
                .utc()
                .format("YYYY-MM-DD")
            : null
      };
      let cardId = card.cardData.id;
      try {
        let res = await patchTaskBoard(cardId, payload);
        const statusIds = [
          this.statusIdOne,
          this.statusIdTwo,
          this.statusIdThree,
          this.statusIdFour,
          this.statusIdFive,
        ]
        let toIndex = statusIds.findIndex(
          status => res.data.status.id === status
        );
        let fromIndex = statusIds.findIndex(
          status => card.cardData.status.id === status
        );
        // keep the reactive properites in sync with the API data
        let cardInfoObject = card.list.find(card => card.id === cardId);
        cardInfoObject.status = res.data.status;
        cardInfoObject.position = res.data.position;
        // reload the queues
        if (res.data.isPositionReset) {
          this.reloadAllQueues();
        } else {
          this.reloadQueues(fromIndex, toIndex, true);
        }
      } catch (e) {
        console.log(e);
        // e.g. the completed-task lock window has closed - the card already
        // moved visually via onDrop, so reload to snap it back to the real
        // server state. Same toast treatment as the 2-running-timers cap.
        this.$bvToast.toast(
          e.response?.data?.detail || "Unable to move this task.",
          {
            title: "⚠ Task",
            variant: "danger",
            solid: true,
            autoHideDelay: 8000,
            toaster: "b-toaster-top-center",
            toastClass: "hr-toast-alert"
          }
        );
        this.reloadAllQueues();
      }
    },
    fixDragAndDropMobile() {
      document.body.classList.remove(
        "smooth-dnd-no-user-select",
        "smooth-dnd-disable-touch-action"
      );
    },
    onDrop(collection, dropResult) {
      this.shouldPatch = true;
      this[collection] = applyDrag(this[collection], dropResult);
    },
    getChildPayload1(index) {
      return this.dailyTasks[index];
    },
    getChildPayload2(index) {
      return this.todoTasks[index];
    },
    getChildPayload3(index) {
      return this.laterTasks[index];
    },
    getChildPayload4(index) {
      return this.inProgressTasks[index];
    },
    getChildPayload5(index) {
      return this.completedTasks[index];
    },
    getMoment: item => {
      if (item.lastTracker.startAt === null) {
        return 0;
      } else if (item.lastTracker.stopAt === null) {
        let duration = moment()
          .utc()
          .diff(item.lastTracker.startAt, "seconds");
        duration += item.trackersLog.timeSpent;
        return duration;
      } else {
        let duration = item.trackersLog.timeSpent;
        return duration;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.task-cards-wrapper {
  height: 90%;
  > div:first-child {
    padding-left: 0.2rem;
  }
}
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.no-assigned-msg {
  width: 95%;
  top: 75%;
}
.container {
  padding: 0 0.2rem;
}
.tab-content {
  height: 80% !important;
}

.empty-container {
  height: auto;
}
.tabs {
  height: 90%;
}
.cards-container {
  height: 100%;
}
div.card.task-cards-wrapper {
  max-height: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  > div:nth-child(1) {
    // status title: Today, Later, etc
    flex: 0 0 auto;
  }
  > div:nth-child(2) {
    // scrollable container for cards
    flex: 1 1 auto;
    display: flex;
    min-height: 0;
  }
  > div:nth-child(3) {
    // + Add another task
    height: 10%;
  }
}
.task-dashboard-row {
  // height: 80%;
  padding-bottom: 10px;
}
.add-another-task {
  margin-top: 0rem !important;
  margin-bottom: 0rem;
}
</style>
